
<template>
  <v-container class="report-daily">
    <div class="d-flex align-center mb-4">
      <v-icon size="32" class="mr-3">mdi-chart-timeline-variant</v-icon>
      <h1 class="text-h4 font-weight-medium mb-0">Relatório diário</h1>
    </div>

    <template v-if="!activeModalityId || activeModalityId == -1 || activeModalityId == '-1'">
      <v-row class="mt-3">
        <v-col cols="12">
          <v-alert type="warning" outlined rounded>
            <span class="d-flex align-center">
              <v-icon left>mdi-map-marker-radius</v-icon>
              Selecione a região
            </span>
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-card rounded="lg" outlined class="mb-4 pa-3 toolbar-card">
        <v-row justify="space-between" align="center" class="ma-1 flex-wrap">
          <div class="d-flex align-center flex-grow-1 flex-shrink-0">
            <v-dialog ref="dialog" :return-value.sync="date_search" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :value="formattedDateSearch"
                  label="Data de pesquisa"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  hide-details
                  class="date-field"
                />
              </template>
              <v-date-picker v-model="date_search" color="primary" locale="pt-br" scrollable v-if="!loading_report">
                <v-spacer />
                <v-btn text icon color="success" @click="$refs.dialog.save(date_search); getReports()">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-spacer />
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="d-flex flex-wrap align-center justify-end mt-2 mt-sm-0">
            <setup-goals class="ma-1" @done="handleDoneSetupGoals" />
            <setup-seller-goals class="ma-1" @done="handleDoneSetupSellerGoals" :report="report" />
            <setup-holidays class="ma-1" @done="handleDoneSetupHolidays" />
          </div>
        </v-row>
      </v-card>

      <div class="mb-4">
        <header-display :report="report" :modality_name="modality_name" />
      </div>

      <div class="mb-4">
        <SellerConsolidatedGoals :sellers="sellers" :report="report" :date_search="date_search" :loading="loading_report" />
      </div>

      <v-card rounded="lg" outlined class="chart-card">
        <v-card-title class="text-h6 font-weight-medium py-4">
          <v-icon left color="primary">mdi-chart-line</v-icon>
          Gráfico ({{ modality_name || 'Região' }})
        </v-card-title>
        <v-card-text class="pt-0">
          <SellLineChart :date_search="date_search" :active-modality-id="activeModalityId" />
        </v-card-text>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import Api from '@/api/index'

export default {
  name: "MainDaily",
  components: {
    SetupHolidays: () => import('./SetupHolidays.vue'),
    SetupSellerGoals: () => import('./SetupSellerGoals.vue'),
    SetupGoals: () => import('./SetupGoals.vue'),

    SellerConsolidatedGoals: () => import('./SellerConsolidatedGoals.vue'),
    OneMonth: () => import('./OneMonth.vue'),
    SellLineChart: () => import('./SellLineChart.vue'),
    HeaderDisplay: () => import('./HeaderDisplay.vue'),
  },
  data() {
    return {
      daily_tab: null,
      report: {},
      sellers:[],
      loading_report: false,
      date_search: new Date().toISOString().substring(0, 10),
    }
  },
  methods: {
    getData(){
      this.setDate()
      this.getReports()
    },
    getReports(){
      this.getSellerReports()
      this.getModalitySellerReport()
    },
    setDate() {
      let day = this.$moment()
      if (day.weekday(Number) == 0) {
        day = this.$moment().subtract(1, 'day')
      }
      day = day.subtract(1, 'day').format('YYYY-MM-DD')
      this.date_search = day
    },
    getModalitySellerReport(){
      if (this.activeModalityId) {
        this.loading_report = true
        let date = this.date_search
        Api.SellerDailyReport.indexModalitySellerReports({
          date,
          modality_id: this.activeModalityId
        }).then(r => r.data).then((data) => {
          this.report = (data && typeof data === 'object' && !Array.isArray(data)) ? { ...data } : (data?.data ? { ...data.data } : {})
        }).catch((err) => {
          this.report = {}
          let msg = err?.response?.data?.error || err?.response?.data?.errors?.[0] || err?.message || 'Erro ao carregar relatório.'
          console.error(msg, err)
        }).finally(() => {
          this.loading_report = false
        })
      }
    },
    getSellerReports() {
      if (!this.activeModalityId) return
      this.loading_report = true
      let date = this.date_search
      Api.SellerDailyReport.indexSellerReports({
        date,
        modality_id: this.activeModalityId
      }).then(r => r.data).then((data) => {
        let list = Array.isArray(data) ? data : (data?.data ? data.data : [])
        this.sellers = [...list]
      }).catch((err) => {
        this.sellers = []
        let msg = err?.response?.data?.error || err?.response?.data?.errors?.[0] || err?.message || 'Erro ao carregar vendedores.'
        console.error(msg, err)
      }).finally(() => {
        this.loading_report = false
      })
    },
    handleDoneSetupGoals() {
      this.reloadDailyReport()
    },
    handleDoneSetupSellerGoals() {
      this.reloadDailyReport()
    },
    handleDoneSetupHolidays() {
      this.reloadDailyReport()
    },
    reloadDailyReport() {
      this.getReports()
    },
  },
  computed: {
    formattedDateSearch() {
      if (!this.date_search || this.date_search.length < 10) return ''
      try {
        return new Date(this.date_search.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR')
      } catch (_) {
        return this.date_search
      }
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    activeModalityId() {
      this.getData()
    },
  },
}
</script>

<style scoped>
.report-daily {
  max-width: 1400px;
}
.toolbar-card {
  background-color: #f5f7fa;
}
.date-field {
  max-width: 220px;
}
</style>